import { ReactElement } from 'react';
import { UnitCard } from 'pages/NewOverview/components/UnitCard';
import { ThermalComfortVariant } from './types';
import { IconNames } from 'pages/NewOverview/types';
import { colors } from 'styles/colors';
import { t } from 'i18next';

interface UnitCardProps {
  variant: ThermalComfortVariant;
  value?: number;
  onClickDetails?: () => void;
  canSeeDetails?: boolean;
}

interface VariantConfig {
  cardColor: string;
  iconColor: string;
  icon: IconNames;
  description: string;
}

const variantConfigs: Record<ThermalComfortVariant, VariantConfig> = {
  aboveLimit: {
    cardColor: colors.bg['danger-light-0'],
    description: t('unidadesAcimaDoLimite'),
    icon: 'WavesIcon',
    iconColor: colors.state.danger.base,
  },
  belowLimit: {
    cardColor: colors.state.cold.lighter,
    description: t('unidadesAbaixoDoLimite'),
    icon: 'SnowflakeIcon',
    iconColor: colors.state.cold.base,
  },
  comfortable: {
    cardColor: colors.bg['success-light'],
    description: t('unidadesConfortaveis'),
    icon: 'Check',
    iconColor: colors.state.success.base,
  },
  inoperative: {
    cardColor: colors.bg['weak-100'],
    iconColor: colors.bg['soft-400'],
    description: t('unidadesInoperantes'),
    icon: 'SlashCircle1Icon',
  },
};

export function ThermalComfortUnitCard({
  variant,
  onClickDetails,
  value,
  canSeeDetails = true,
}: Readonly<UnitCardProps>): ReactElement {
  const config = variantConfigs[variant];
  const size = 18;

  return (
    <UnitCard
      cardColor={config.cardColor}
      description={config.description}
      icon={{
        color: config.iconColor,
        name: config.icon,
        size,
      }}
      value={value}
      onClickDetails={canSeeDetails ? onClickDetails : undefined}
      disabledReasonKey={!canSeeDetails ? 'semUnidadesNesseStatus' : undefined}
    />
  );
}
